import { useNavigate } from "react-router-dom";
export function useSmartBackToPreviousPath() {
  const navigate = useNavigate();
  return () => {
    const history = JSON.parse(sessionStorage.getItem('pathHistory') || '[]');
    if (history.length > 1) {
      history.pop(); 
      const previous = history.pop(); 
      sessionStorage.setItem('pathHistory', JSON.stringify(history));
      navigate(previous);
    } else {
      navigate(-1); 
    }
  };
}